import { Controller } from "stimulus";

// Rewrites a server-rendered start time into the browser's timezone. Mirrors
// LivePagesHelper#live_event_start_time ("Oct 9, 2026 - 3:00pm EDT") so the first paint and the
// rewrite agree. The server text stays as the no-JS fallback; an unparseable `datetime` leaves it alone.
const FORMAT = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
  year: "numeric",
  hour: "numeric",
  hour12: true,
  minute: "2-digit",
  timeZoneName: "short",
});

// Date-only styles, mirroring LivePagesHelper#local_date_tag: "weekday" is "Wed, Dec 4, 2030", "date" is "Dec 4, 2030", "short" is "Dec 4".
const DATE_FORMATS = {
  weekday: new Intl.DateTimeFormat("en-US", { weekday: "short", month: "short", day: "numeric", year: "numeric" }),
  date: new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric", year: "numeric" }),
  short: new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric" }),
};

export default class extends Controller {
  static values = { format: String };

  connect() {
    const time = Date.parse(this.element.dateTime);
    if (Number.isNaN(time)) return;

    const dateFormat = DATE_FORMATS[this.formatValue];
    if (dateFormat) {
      this.element.textContent = dateFormat.format(new Date(time));
      return;
    }

    const parts = Object.fromEntries(FORMAT.formatToParts(new Date(time)).map((p) => [p.type, p.value]));
    this.element.textContent = `${parts.month} ${parts.day}, ${parts.year} - ${parts.hour}:${parts.minute}${parts.dayPeriod.toLowerCase()} ${parts.timeZoneName}`;
  }
}
